import axios, { AxiosInstance, AxiosRequestConfig, AxiosError } from "axios";
import { authInterceptor } from './interceptors';
import { parseError, ErrorType } from './errorParser';
import { removeCookie } from '../utils/cookie';
import { API_CONFIG, AUTH_PATHS } from '../constants';

const apiClient: AxiosInstance = axios.create({
    baseURL: API_CONFIG.BASE_URL,
    timeout: API_CONFIG.TIMEOUT,
    headers: {
        'Content-Type': 'application/json',
    },
});

apiClient.interceptors.request.use(
    authInterceptor.onRequest,
    authInterceptor.onRequestError
);

apiClient.interceptors.response.use(
    (response) => response,
    (error: AxiosError | unknown) => {
        const parsed = parseError(error);
        
        if (parsed.type === ErrorType.UNAUTHORIZED) {
            removeCookie('accessToken', '/');
            removeCookie('refreshToken', '/');
            
            localStorage.removeItem('userInfo');
            localStorage.removeItem('userId');
            
            const currentPath = window.location.pathname;
            if (!AUTH_PATHS.NO_AUTH_REQUIRED.some(path => currentPath.startsWith(path))) {
                window.location.href = '/login';
            }
        }
        
        return Promise.reject(parsed);
    }
);

export { apiClient };
